(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1989],{

/***/ 18774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Button_Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/forward-ref/index.js
var forward_ref = __webpack_require__(52418);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Button/Button.js







const Button = (param)=>{
    let { Tag ="button" , type ="button" , styleType ="primary" , isTheme =false , isOutline =false , isOutline2 =false , isBlock =false , isPreLine =false , size , disabled =false , className , forwardRef , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , ...props } = param;
    const tabType = Tag !== "a" && {
        type
    };
    const themeClassName = !isTheme ? [
        !isOutline && !isOutline2 && "btn-".concat(styleType),
        isOutline && "btn-outline-".concat(styleType),
        isOutline2 && "btn-outline2-".concat(styleType)
    ] : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
        ...tabType,
        ref: forwardRef,
        className: (0,classes/* classes */.S)("btn", ...themeClassName, isBlock && "btn-block", isPreLine && "btn--pre-line", size && "btn-".concat(size), disabled && "disabled", ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props
    });
};
Button.propTypes = {
    Tag: (0,prop_types.oneOfType)([
        (0,prop_types.oneOf)([
            "a",
            "button"
        ]),
        prop_types.elementType
    ]),
    type: (0,prop_types.oneOf)([
        "button",
        "submit",
        "reset"
    ]),
    styleType: (0,prop_types.oneOf)([
        "primary",
        "secondary",
        "success",
        "danger",
        "warning",
        "info",
        "gray",
        "dark",
        "light",
        "info-light",
        "link",
        "copy",
        "input-group"
    ]),
    isTheme: prop_types.bool,
    isOutline: prop_types.bool,
    isOutline2: prop_types.bool,
    isBlock: prop_types.bool,
    isPreLine: prop_types.bool,
    disabled: prop_types.bool,
    size: (0,prop_types.oneOf)([
        "xs",
        "s",
        "m",
        "l"
    ]),
    className: prop_types.string,
    forwardRef: forward_ref/* default */.Z,
    focus: prop_types.bool,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
const ButtonLink = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
        Tag: "a",
        ...props
    });
Button.Link = ButtonLink;
/* harmony default export */ var Button_Button = ((0,pureFC/* default */.Z)(Button));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js



/***/ }),

/***/ 38661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const FooterContainer = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
            mx: true,
            px: true,
            children: children
        })
    });
};
FooterContainer.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container.propTypes */ .W2.propTypes,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (FooterContainer);


/***/ }),

/***/ 7212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X6": function() { return /* binding */ FooterCopyrightLink; },
/* harmony export */   "rQ": function() { return /* binding */ FooterCopyrightText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67478);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25522);






const FooterCopyright = (param)=>/*#__PURE__*/ {
    let { className ="" , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("footer__copyright", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X2, {
            mx: true,
            py: true,
            sx: {
                textAlign: "center",
                lg: {
                    textAlign: "right"
                }
            },
            children: children
        })
    });
};
FooterCopyright.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const FooterCopyrightText = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Col */ .JX, {
        spacing: {
            pt: 0
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "footer__copyright_text",
            children: children
        })
    });
};
FooterCopyrightText.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const FooterCopyrightLink = (param)=>{
    let { href , className ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        isBaseClassName: false,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("footer__copyright_link", className),
        href: href,
        ...props,
        children: children
    });
};
FooterCopyrightLink.propTypes = {
    href: prop_types__WEBPACK_IMPORTED_MODULE_5__.string.isRequired,
    className: prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const CompanyName = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "footer__copyright_company",
        children: children
    });
};
CompanyName.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
FooterCopyrightText.CompanyName = CompanyName;
/* harmony default export */ __webpack_exports__["ZP"] = (FooterCopyright);


/***/ }),

/***/ 33768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);
/* harmony import */ var _LogoLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46096);





const FooterLogo = (param)=>/*#__PURE__*/ {
    let { logoPath , logoAlt =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LogoLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            imgSrc: logoPath,
            alt: logoAlt
        })
    });
};
FooterLogo.propTypes = {
    logoPath: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    logoAlt: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (FooterLogo);


/***/ }),

/***/ 78682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const FooterMainContainer = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        lg: 9,
        ...props,
        children: children
    });
};
FooterMainContainer.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col.propTypes */ .JX.propTypes,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (FooterMainContainer);


/***/ }),

/***/ 53512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hr": function() { return /* binding */ FooterNavList; },
/* harmony export */   "Pw": function() { return /* binding */ FooterNavCol; },
/* harmony export */   "Q1": function() { return /* binding */ FooterNavListTitle; },
/* harmony export */   "iT": function() { return /* binding */ FooterNavListItem; },
/* harmony export */   "jO": function() { return /* binding */ FooterNavItemLink; },
/* harmony export */   "z4": function() { return /* binding */ FooterNavRow; }
/* harmony export */ });
/* unused harmony export FooterNavTitleLink */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25522);
/* harmony import */ var _Block__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6949);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67924);







const FooterNav = (param)=>/*#__PURE__*/ {
    let { className ="" , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_5__/* .classes */ .S)("footer__nav", className),
        ...props
    });
};
FooterNav.propTypes = {
    ..._Block__WEBPACK_IMPORTED_MODULE_4__/* ["default"].propTypes */ .Z.propTypes
};
const FooterNavRow = (param)=>/*#__PURE__*/ {
    let { children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
        mx: true,
        py: true,
        ...props,
        children: children
    });
};
FooterNavRow.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row.propTypes */ .X2.propTypes,
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired
};
const FooterNavCol = (param)=>/*#__PURE__*/ {
    let { sm =6 , md ="shrink" , lg ="shrink" , className ="" , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        sm: sm,
        md: md,
        lg: lg,
        className: className,
        children: children
    });
};
FooterNavCol.propTypes = {
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_6__.oneOf)([
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_6__.oneOf)([
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_6__.oneOf)([
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired
};
const FooterNavList = (param)=>{
    let { className ="" , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_5__/* .classes */ .S)("footer__nav-list", className),
        children: children
    });
};
FooterNavList.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired
};
const FooterNavListItem = (param)=>{
    let { enable =true , className ="" , children  } = param;
    return enable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_5__/* .classes */ .S)("footer__nav-list_item", className),
        children: children
    }) : null;
};
FooterNavListItem.propTypes = {
    enable: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired
};
const FooterNavItemLink = (param)=>{
    let { children , className ="" , href ="/" , isBold =false , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        isBaseClassName: false,
        href: href,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_5__/* .classes */ .S)("footer__nav-list_item-link", isBold && "footer__nav-list_item-link--bold", className),
        ...props,
        children: children
    });
};
FooterNavItemLink.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    isBold: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string
};
const FooterNavListTitle = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "footer__nav-list_title",
        children: children
    });
};
FooterNavListTitle.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired
};
const FooterNavTitleLink = (param)=>{
    let { children , className ="" , href ="/" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        isBaseClassName: false,
        href: href,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_5__/* .classes */ .S)("footer__nav-list_title-link", className),
        ...props,
        children: children
    });
};
FooterNavTitleLink.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string
};
/* harmony default export */ __webpack_exports__["ZP"] = (FooterNav);


/***/ }),

/***/ 58287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const FooterSideBarContainer = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        lg: 3,
        ...props,
        children: children
    });
};
FooterSideBarContainer.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col.propTypes */ .JX.propTypes,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (FooterSideBarContainer);


/***/ }),

/***/ 72025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ FooterSocialItemLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25522);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61672);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67924);







const FooterSocial = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        spacing: {
            pt: 0
        },
        children: children
    });
};
FooterSocial.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired
};
const FooterSocialItemLink = (param)=>{
    let { name , href , className ="" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        isBaseClassName: false,
        href: href,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_5__/* .classes */ .S)("footer__social_item-link", className),
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            name: name
        })
    });
};
FooterSocialItemLink.propTypes = {
    name: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (FooterSocial);


/***/ }),

/***/ 9458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Footer_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureProps.js
var pureProps = __webpack_require__(7820);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/Footer.js








const Footer = (param)=>{
    let { utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , isBorderNone =false , className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: (0,classes/* classes */.S)("footer", ...(0,props_utility/* utilityClassName */.b2)((0,pureProps/* deepMergeProps */.p)(isBorderNone ? {
            border: {
                width: 0
            }
        } : {}, (0,pureProps/* default */.Z)(utility))), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        children: children
    });
};
Footer.propTypes = {
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    isBorderNone: prop_types.bool,
    className: prop_types.string,
    children: prop_types.node.isRequired
};
/* harmony default export */ var Footer_Footer = (Footer);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/index.js



/***/ }),

/***/ 36432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ HeroRow; },
/* harmony export */   "Z": function() { return /* binding */ HeroCol; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);



const HeroCol = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        md: "shrink",
        ...props
    });
};
HeroCol.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col.propTypes */ .JX.propTypes
};
const HeroRow = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
        mx: true,
        my: true,
        center: true,
        ...props
    });
};
HeroRow.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row.propTypes */ .X2.propTypes
};


/***/ }),

/***/ 74229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Paragraph_Paragraph; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureProps.js
var pureProps = __webpack_require__(7820);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/fontWeight.js
var fontWeight = __webpack_require__(36336);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/Paragraph.js










const Paragraph = (param)=>{
    let { Tag ="p" , size , center , uppercase =false , color , className ="" , block =false , weight , italic , utility ={
        ...props_utility/* utilityProps */.Gm
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , ...props } = param;
    const fontSizeProp = size ? {
        fontSize: size
    } : {};
    const fontWeightProp = weight ? {
        fontWeight: weight
    } : {};
    const fontColorProp = color ? {
        fontColor: color
    } : {};
    const fontStyleProp = italic ? {
        fontStyle: "italic"
    } : {};
    const textAlignProp = center ? {
        textAlign: "center"
    } : {};
    const textTransformProp = uppercase ? {
        textTransform: "uppercase"
    } : {};
    const displayProp = block ? {
        display: "block"
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
        className: (0,classes/* classes */.S)(...(0,props_utility/* utilityClassName */.b2)((0,pureProps/* deepMergeProps */.p)({
            ...displayProp
        }, (0,pureProps/* default */.Z)(utility))), ...(0,props_sx/* sxClassName */.ZA)((0,pureProps/* deepMergeProps */.p)({
            ...fontWeightProp,
            ...fontSizeProp,
            ...fontColorProp,
            ...fontStyleProp,
            ...textAlignProp,
            ...textTransformProp
        }, (0,pureProps/* default */.Z)(sx))), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props
    });
};
Paragraph.propTypes = {
    Tag: prop_types.string,
    size: props_sx/* fontSizePropTypes */.Gk,
    italic: prop_types.bool,
    center: prop_types.bool,
    block: prop_types.bool,
    uppercase: prop_types.bool,
    weight: (0,prop_types.oneOf)(Object.keys(fontWeight/* default */.Z)),
    color: props_sx/* colorPropTypes */.AK,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    className: prop_types.string
};
/* harmony default export */ var Paragraph_Paragraph = ((0,pureFC/* default */.Z)(Paragraph));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js



/***/ }),

/***/ 93512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Section_Section; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Section/Section.js






const Section = (param)=>{
    let { className ="" , children , utility ={
        ...props_utility/* utilityProps */.Gm
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (0,classes/* classes */.S)(...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props,
        children: children
    });
};
Section.propTypes = {
    className: prop_types.string,
    utility: props_utility/* utilityPropTypes */.pQ,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    children: prop_types.node.isRequired
};
/* harmony default export */ var Section_Section = (Section);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js



/***/ }),

/***/ 19334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SectionTryForFree_SectionTryForFree; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/SectionTryForFree.js





const Title = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section-try-for-free__title",
        children: children
    });
};
Title.propTypes = {
    children: prop_types.node.isRequired
};
const Action = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section-try-for-free__action",
        children: children
    });
};
Action.propTypes = {
    children: prop_types.node.isRequired
};
const SectionTryForFree = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: "section-try-for-free",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    children: children
                })
            })
        })
    });
};
SectionTryForFree.propTypes = {
    children: prop_types.node.isRequired
};
SectionTryForFree.Title = Title;
SectionTryForFree.Action = Action;
/* harmony default export */ var SectionTryForFree_SectionTryForFree = (SectionTryForFree);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/index.js



/***/ }),

/***/ 97849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Item; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Tabs/Grid.js






const TabCol = (param)=>/*#__PURE__*/ {
    let { className , cell ="" , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , ...props } = param;
    return (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
        className: (0,classes/* classes */.S)(cell, ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props,
        role: "presentation"
    });
};
TabCol.propTypes = {
    cell: prop_types.string,
    ...Grid/* Col.propTypes */.JX.propTypes
};

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureProps.js
var pureProps = __webpack_require__(7820);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Tabs/Title.js









const TabTitle = (param)=>{
    let { Tag =Link/* default */.Z , tabType =1 , tabID ="" , isAnchor =false , active =false , className , px =true , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , ...props } = param;
    const ResultTag = active ? "span" : Tag;
    const anchor = isAnchor ? {
        id: "".concat(tabID, "-tab"),
        href: "#".concat(tabID)
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultTag, {
        "data-toggle": "tab",
        role: "tab",
        "aria-controls": tabID,
        "aria-selected": active,
        className: (0,classes/* classes */.S)("tabs-v".concat(tabType, "__item"), active && "tabs-v".concat(tabType, "__item--active"), ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)((0,pureProps/* deepMergeProps */.p)(px ? {
            md: {
                px: 10
            }
        } : {}, (0,pureProps/* default */.Z)(spacing))), className),
        ...anchor,
        ...props
    });
};
TabTitle.propTypes = {
    Tag: prop_types.elementType,
    tabID: prop_types.string,
    tabType: (0,prop_types.oneOf)([
        1,
        2
    ]),
    isAnchor: prop_types.bool,
    active: prop_types.bool,
    px: prop_types.bool,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    className: prop_types.string
};
/* harmony default export */ var Title = (TabTitle);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Tabs/Item.js





const TabItem = (param)=>{
    let { tabType =1 , active =false , tabClassName , cell ="medium-shrink" , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabCol, {
        className: tabClassName,
        cell: cell,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
            tabType: tabType,
            active: active,
            ...props
        })
    });
};
TabItem.propTypes = {
    cell: prop_types.string,
    tabType: (0,prop_types.oneOf)([
        1,
        2
    ]),
    tabClassName: prop_types.string,
    active: prop_types.bool,
    ...Title.propTypes
};
/* harmony default export */ var Item = (TabItem);


/***/ }),

/***/ 77739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Tabs_Tabs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Tabs/Tabs.js






const Tabs = (param)=>{
    let { tabsID ="" , tabsType =1 , isBorderBottom =true , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        id: tabsID,
        className: (0,classes/* classes */.S)("tabs-v".concat(tabsType), isBorderBottom && "tabs-v".concat(tabsType, "--border-bottom"), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        role: "tablist",
        ...props,
        children: children
    });
};
Tabs.propTypes = {
    isBorderBottom: prop_types.bool,
    tabsType: (0,prop_types.oneOf)([
        1,
        2
    ]),
    tabsID: prop_types.string,
    className: prop_types.string,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    children: prop_types.node.isRequired
};
/* harmony default export */ var Tabs_Tabs = (Tabs);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Tabs/index.js



/***/ }),

/***/ 94394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);




const WistiaVideoEmbed = (param)=>{
    let { id , className =""  } = param;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const script = document.createElement("script");
        script.src = "https://fast.wistia.com/embed/medias/".concat(id, ".jsonp");
        script.async = true;
        document.body.appendChild(script);
        return ()=>{
            script.remove();
        };
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("wistia_embed", "wistia_async_".concat(id), "wistia-block-detail__embed", "videoFoam=true", className)
    });
};
WistiaVideoEmbed.propTypes = {
    id: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired,
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (WistiaVideoEmbed);


/***/ }),

/***/ 6292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ WistiaVideo_WistiaVideo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/WistiaVideo/WistiaVideo.js



const WistiaVideo = (param)=>{
    let { children  } = param;
    (0,react.useEffect)(()=>{
        if (!document.getElementById("wistia_script")) {
            const wistiaScript = document.createElement("script");
            wistiaScript.id = "wistia_script";
            wistiaScript.type = "text/javascript";
            wistiaScript.src = "https://fast.wistia.com/assets/external/E-v1.js";
            wistiaScript.async = true;
            document.body.appendChild(wistiaScript);
            /* eslint no-underscore-dangle: ["error", { "allow": ["_wq"] }] */ window._wq = window._wq || [];
            // eslint-disable-next-line no-undef
            _wq.push({
                id: "_all",
                onReady (video) {
                    video.bind("play", ()=>{
                        // eslint-disable-next-line no-undef
                        const allVideos = Wistia.api.all();
                        allVideos.forEach((v)=>{
                            if (v.uuid !== video.uuid) {
                                v.pause();
                            }
                        });
                    });
                }
            });
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "wistia-video-container",
        children: children
    });
};
WistiaVideo.propTypes = {
    children: prop_types.node.isRequired
};
/* harmony default export */ var WistiaVideo_WistiaVideo = (WistiaVideo);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/WistiaVideo/index.js



/***/ }),

/***/ 12985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const ContentContainer = (param)=>{
    let { mx =false , px =false , my =false , py =false , sm ="" , md ="" , lg ="" , center =false , containerClassName ="" , className ="" , isFluid =false , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
        className: containerClassName,
        isFluid: isFluid,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
            mx: mx,
            px: px,
            my: my,
            py: py,
            className: className,
            center: center,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                sm: sm,
                md: md,
                lg: lg,
                children: children
            })
        })
    });
};
ContentContainer.propTypes = {
    mx: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    px: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    my: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    py: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    center: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    containerClassName: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    isFluid: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentContainer);


/***/ }),

/***/ 27276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q0": function() { return /* reexport */ BlockQuote_BlockQuote; },
  "_w": function() { return /* reexport */ Thumb; },
  "ZP": function() { return /* reexport */ Slider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/BlockQuote/BlockQuote.js




const BlockQuote = (param)=>{
    let { author , jobTitle ="" , institution , active =false , isBorderNone =false , className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,classes/* classes */.S)("bq__item", active && "bq__item--active", isBorderNone && "bq__item--border-none", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bq__item-message",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bq__item-author",
                children: author
            }),
            jobTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bq__item-job-title",
                children: jobTitle
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bq__item-institution",
                children: institution
            })
        ]
    });
};
BlockQuote.propTypes = {
    author: prop_types.string.isRequired,
    jobTitle: prop_types.string,
    institution: prop_types.string.isRequired,
    active: prop_types.bool,
    isBorderNone: prop_types.bool,
    className: prop_types.string,
    children: prop_types.node.isRequired
};
/* harmony default export */ var BlockQuote_BlockQuote = (BlockQuote);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/BlockQuote/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/BlockQuote/Thumb.js






const BlockQuoteThumb = (param)=>{
    let { className ="" , src , alt ="" , active =false , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
        ...props,
        md: "auto",
        className: (0,classes/* classes */.S)("bq__item-thumb", active && "bq__item-thumb--active", className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
            utility: {
                align: {
                    items: "center"
                }
            },
            className: "bq__item-thumb-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: src,
                    alt: alt
                })
            })
        })
    });
};
BlockQuoteThumb.propTypes = {
    src: prop_types.string.isRequired,
    alt: prop_types.string,
    active: prop_types.bool,
    className: prop_types.string
};
/* harmony default export */ var Thumb = (BlockQuoteThumb);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/ContentContainer/index.js
var ContentContainer = __webpack_require__(12985);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/BlockQuote/Slider.js






const Head = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        id: "BlockQuoteHead",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
            children: children
        })
    });
};
Head.propTypes = {
    children: prop_types.node.isRequired
};
const Thumbs = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        mx: true,
        id: "BlockQuoteThumbs",
        spacing: {
            mb: 15
        },
        children: children
    });
};
Thumbs.propTypes = {
    children: prop_types.node.isRequired
};
const Footer = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
            children: children
        })
    });
};
Footer.propTypes = {
    children: prop_types.node.isRequired
};
const BlockQuoteSlider = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        spacing: {
            pb: 20
        },
        className: "bq",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
            lg: 10,
            center: true,
            children: children
        })
    });
};
BlockQuoteSlider.propTypes = {
    children: prop_types.node.isRequired
};
BlockQuoteSlider.Head = Head;
BlockQuoteSlider.Thumbs = Thumbs;
BlockQuoteSlider.Footer = Footer;
/* harmony default export */ var Slider = (BlockQuoteSlider);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/r1/molecules/BlockQuote/index.js
// TODO: import to this file is deprecated!






/***/ }),

/***/ 75590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6949);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67478);
/* harmony import */ var _atoms_ContentContainer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12985);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25522);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10334);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74229);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42866);
/* harmony import */ var _Section__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93512);











const HomeNewAndNoteworthy = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        utility: {
            border: {
                bottom: {
                    width: 1,
                    color: "black--15"
                }
            }
        },
        spacing: {
            pb: 5
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_ContentContainer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            lg: 10,
            center: true,
            children: children
        })
    });
};
HomeNewAndNoteworthy.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_10__.node.isRequired
};
const HomeNewAndNoteworthyTitle = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        Tag: "h2",
        sx: {
            fontSize: "xl",
            textAlign: "center"
        },
        spacing: {
            mt: 20,
            mb: 20
        },
        children: children
    });
};
HomeNewAndNoteworthyTitle.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_10__.string.isRequired
};
const HomepageNewAndNoteworthyList = (param)=>{
    let { children  } = param;
    return children;
};
HomepageNewAndNoteworthyList.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_10__.node.isRequired
};
const HomepageNewAndNoteworthyListItem = (param)=>{
    let { id , title , srcImg , href , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X2, {
        id: id,
        spacing: {
            mb: 20
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Col */ .JX, {
                lg: 5,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    spacing: {
                        mb: 4,
                        lg: {
                            mb: 0
                        }
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        href: href,
                        isBaseClassName: false,
                        utility: {
                            display: "block"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            src: srcImg,
                            alt: title
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Col */ .JX, {
                lg: 7,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    spacing: {
                        lg: {
                            ml: 12
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            Tag: "h3",
                            sx: {
                                fontSize: "l"
                            },
                            spacing: {
                                mt: "m1"
                            },
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            sx: {
                                fontSize: "m"
                            },
                            spacing: {
                                mb: 2
                            },
                            children: children
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            spacing: {
                                my: 0
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                href: href,
                                isBaseClassName: false,
                                children: "Learn More"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
HomepageNewAndNoteworthyListItem.propTypes = {
    id: prop_types__WEBPACK_IMPORTED_MODULE_10__.string.isRequired,
    title: prop_types__WEBPACK_IMPORTED_MODULE_10__.string.isRequired,
    srcImg: prop_types__WEBPACK_IMPORTED_MODULE_10__.string.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_10__.string.isRequired,
    children: prop_types__WEBPACK_IMPORTED_MODULE_10__.string.isRequired
};
HomeNewAndNoteworthy.Title = HomeNewAndNoteworthyTitle;
HomeNewAndNoteworthy.List = HomepageNewAndNoteworthyList;
HomeNewAndNoteworthy.List.Item = HomepageNewAndNoteworthyListItem;
/* harmony default export */ __webpack_exports__["Z"] = (HomeNewAndNoteworthy);


/***/ }),

/***/ 50758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _insightfulscience_atomic_react_Inline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31987);
/* harmony import */ var _Block__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6949);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67478);
/* harmony import */ var _atoms_ContentContainer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12985);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25522);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42866);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10334);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74229);
/* harmony import */ var _Section__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93512);












const HomeResourcesHead = (param)=>{
    let { title , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Block__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        spacing: {
            mb: 20
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                Tag: "h2",
                sx: {
                    fontSize: "xl",
                    textAlign: "center"
                },
                spacing: {
                    mt: 20
                },
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                sx: {
                    fontSize: "l",
                    textAlign: "center"
                },
                children: children
            })
        ]
    });
};
HomeResourcesHead.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired,
    children: (0,prop_types__WEBPACK_IMPORTED_MODULE_11__.oneOf)([
        prop_types__WEBPACK_IMPORTED_MODULE_11__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_11__.node
    ])
};
const HomeResourcesBody = (param)=>{
    let { children  } = param;
    return children;
};
HomeResourcesBody.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_11__.node.isRequired
};
const HomeResourcesBodyItem = (param)=>{
    let { title , srcImg , href , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        href: href,
        isBaseClassName: false,
        spacing: {
            mb: 14
        },
        className: "grid-x home-resources-body-item",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
                Tag: "span",
                shrink: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Inline__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    sx: {
                        textAlign: "center"
                    },
                    spacing: {
                        sm: {
                            mb: 4
                        }
                    },
                    utility: {
                        display: "block"
                    },
                    className: "w-18",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        src: srcImg
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
                Tag: "span",
                auto: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Block__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    spacing: {
                        ml: 4,
                        md: {
                            ml: 12
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            Tag: "h3",
                            sx: {
                                fontSize: "m",
                                fontColor: "2"
                            },
                            spacing: {
                                mb: 2
                            },
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            sx: {
                                fontSize: "m",
                                fontColor: "black--85"
                            },
                            spacing: {
                                my: 0
                            },
                            children: children
                        })
                    ]
                })
            })
        ]
    });
};
HomeResourcesBodyItem.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired,
    srcImg: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired,
    children: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired
};
const HomeResources = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Section__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        className: "pb-10",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_ContentContainer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            lg: 8,
            center: true,
            children: children
        })
    });
};
HomeResources.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_11__.node.isRequired
};
HomeResources.Head = HomeResourcesHead;
HomeResources.Body = HomeResourcesBody;
HomeResources.Body.Item = HomeResourcesBodyItem;
/* harmony default export */ __webpack_exports__["Z"] = (HomeResources);


/***/ }),

/***/ 27473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IP": function() { return /* binding */ HomepageHeroHeadLink; },
/* harmony export */   "Z": function() { return /* binding */ HomepageHeroBodyItemLink; },
/* harmony export */   "dz": function() { return /* binding */ HomepageHeroButtonSecondary; },
/* harmony export */   "wk": function() { return /* binding */ HomepageHeroButtonDefault; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Block__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6949);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18774);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67478);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10334);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42866);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74229);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25522);
/* harmony import */ var _atoms_ContentContainer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12985);
/* harmony import */ var _Section__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93512);












const HomepageHero = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Section__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        utility: {
            border: {
                bottom: {
                    width: 1,
                    color: "black--15"
                }
            }
        },
        spacing: {
            pb: 5
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_ContentContainer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            lg: 8,
            center: true,
            children: children
        })
    });
};
HomepageHero.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_11__.node.isRequired
};
const HomepageHeroHead = (param)=>{
    let { children , srcHeroHeadImg  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Row */ .X2, {
                children: children
            }),
            srcHeroHeadImg ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Row */ .X2, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        spacing: {
                            mt: 10,
                            mb: 30
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            src: srcHeroHeadImg
                        })
                    })
                })
            }) : null
        ]
    });
};
HomepageHeroHead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_11__.node.isRequired,
    srcHeroHeadImg: prop_types__WEBPACK_IMPORTED_MODULE_11__.string
};
const HomepageHeroTitle = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            Tag: "h1",
            sx: {
                fontSize: "xxl",
                textAlign: "center"
            },
            spacing: {
                mt: 20
            },
            children: children
        })
    });
};
HomepageHeroTitle.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired
};
const HomepageHeroDescription = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            sx: {
                fontSize: "l",
                textAlign: "center"
            },
            children: children
        })
    });
};
HomepageHeroDescription.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired
};
const HomepageHeroButtons = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            sx: {
                textAlign: "center"
            },
            spacing: {
                mt: 4
            },
            children: children
        })
    });
};
HomepageHeroButtons.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_11__.node.isRequired
};
const HomepageHeroLinks = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            sx: {
                textAlign: "center"
            },
            spacing: {
                mt: 15
            },
            children: children
        })
    });
};
HomepageHeroLinks.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_11__.node.isRequired
};
const HomepageHeroHeadLink = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        sx: {
            fontSize: "s",
            fontColor: "black"
        },
        ...props,
        className: "text-underline",
        children: children
    });
};
HomepageHeroHeadLink.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired
};
HomepageHeroDescription.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired
};
const HomepageHeroButtonDefault = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Link */ .Z.Link, {
        size: "s",
        spacing: {
            mr: 4
        },
        ...props,
        children: children
    });
};
HomepageHeroButtonDefault.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired
};
const HomepageHeroButtonSecondary = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Link */ .Z.Link, {
        size: "s",
        styleType: "secondary",
        isOutline2: true,
        ...props,
        children: children
    });
};
HomepageHeroButtonSecondary.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired
};
const HomepageHeroBody = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Row */ .X2, {
        children: children
    });
};
HomepageHeroBody.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_11__.node.isRequired
};
const HomepageHeroBodyItem = (param)=>{
    let { numItem , title , description , srcImg , href , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
        spacing: {
            mb: 20
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Row */ .X2, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
                        lg: 5,
                        className: "overflow-hidden",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            spacing: {
                                md: {
                                    mt: "m3"
                                }
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Row */ .X2, {
                                middle: true,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
                                        shrink: true,
                                        spacing: {
                                            mr: 4
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "heading heading-xxxl",
                                            children: numItem
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
                                        auto: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            Tag: "h2",
                                            sx: {
                                                fontSize: "l"
                                            },
                                            spacing: {
                                                my: 0
                                            },
                                            children: title
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
                        lg: 7,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                sx: {
                                    fontSize: "m"
                                },
                                spacing: {
                                    mt: 0,
                                    mb: 2
                                },
                                children: description
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                spacing: {
                                    my: 0
                                },
                                children: children
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Row */ .X2, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        spacing: {
                            mt: 4
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            href: href,
                            isBaseClassName: false,
                            utility: {
                                display: "block"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                src: srcImg,
                                alt: title
                            })
                        })
                    })
                })
            })
        ]
    });
};
HomepageHeroBodyItem.propTypes = {
    numItem: prop_types__WEBPACK_IMPORTED_MODULE_11__.number.isRequired,
    title: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired,
    description: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired,
    srcImg: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired,
    children: prop_types__WEBPACK_IMPORTED_MODULE_11__.node.isRequired
};
const HomepageHeroBodyItemLink = (param)=>{
    let { children , href , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        sx: {
            fontSize: "s"
        },
        href: href,
        ...props,
        children: children
    });
};
HomepageHeroBodyItemLink.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_11__.string.isRequired
};
HomepageHero.Head = HomepageHeroHead;
HomepageHeroHead.Title = HomepageHeroTitle;
HomepageHeroHead.Description = HomepageHeroDescription;
HomepageHeroHead.Buttons = HomepageHeroButtons;
HomepageHeroHead.Links = HomepageHeroLinks;
HomepageHero.Body = HomepageHeroBody;
HomepageHero.Body.Item = HomepageHeroBodyItem;
/* harmony default export */ __webpack_exports__["ZP"] = (HomepageHero);


/***/ }),

/***/ 52198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _WistiaVideo__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _WistiaVideo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6292);



/***/ }),

/***/ 53381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export context */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Tabs_Item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97849);




const context = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext({
    active: null,
    setActive: ()=>{}
});
const SmartTabs = (param)=>{
    let { initialActiveTab , children  } = param;
    const [active, setActive] = react__WEBPACK_IMPORTED_MODULE_1__.useState(initialActiveTab);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(context.Provider, {
        value: {
            active,
            setActive
        },
        children: children
    });
};
SmartTabs.propTypes = {
    initialActiveTab: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node
};
const SmartTab = (param)=>{
    let { id , Component =_Tabs_Item__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z , ...props } = param;
    const { active , setActive  } = react__WEBPACK_IMPORTED_MODULE_1__.useContext(context);
    const openTab = react__WEBPACK_IMPORTED_MODULE_1__.useCallback((event)=>{
        event.preventDefault();
        setActive(id);
    }, [
        id,
        setActive
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
        active: id === active,
        onClick: openTab,
        ...props,
        id: id
    });
};
SmartTab.propTypes = {
    id: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node,
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    Component: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOfType)([
        prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_3__.elementType
    ]),
    cell: prop_types__WEBPACK_IMPORTED_MODULE_3__.string
};
const SmartTabBody = (param)=>/*#__PURE__*/ {
    let { id , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(context.Consumer, {
        children: (param)=>{
            let { active  } = param;
            return active === id && children;
        }
    });
};
SmartTabBody.propTypes = {
    id: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node
};
const MountedTabBody = (param)=>/*#__PURE__*/ {
    let { id , children , Component  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(context.Consumer, {
        children: (param)=>/*#__PURE__*/ {
            let { active  } = param;
            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                style: {
                    display: active === id ? "block" : "none"
                },
                children: children
            });
        }
    });
};
MountedTabBody.propTypes = {
    id: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node,
    Component: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOfType)([
        prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_3__.elementType
    ]).isRequired
};
SmartTabBody.Mounted = MountedTabBody;
SmartTabs.Tab = SmartTab;
SmartTabs.TabBody = SmartTabBody;
/* harmony default export */ __webpack_exports__["Z"] = (SmartTabs);


/***/ }),

/***/ 73972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



const Html = (param)=>/*#__PURE__*/ {
    let { Tag ="div" , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        dangerouslySetInnerHTML: {
            __html: children
        },
        ...props
    });
};
Html.propTypes = {
    Tag: (0,prop_types__WEBPACK_IMPORTED_MODULE_2__.oneOfType)([
        prop_types__WEBPACK_IMPORTED_MODULE_2__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_2__.element
    ]),
    children: prop_types__WEBPACK_IMPORTED_MODULE_2__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (Html);


/***/ }),

/***/ 93890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports MetaTwitter, MetaOGP */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84154);





const Robots = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "robots",
            content: content
        })
    });
};
Robots.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Author = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "author",
            content: content
        })
    });
};
Author.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Canonical = (param)=>/*#__PURE__*/ {
    let { href  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "canonical",
            href: href
        })
    });
};
Canonical.propTypes = {
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
};
const CanonicalAlternate = (param)=>/*#__PURE__*/ {
    let { type ="text/html" , hrefLang , href , title =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "alternate",
            type: type,
            hrefLang: hrefLang,
            href: href,
            title: title
        })
    });
};
CanonicalAlternate.propTypes = {
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    hrefLang: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const MetaTwitter = (param)=>{
    let { card ="" , title ="" , description ="" , site ="" , image ="" , creator ="" , isImageBaseUrl =false  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            card && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: card
            }),
            site && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: site
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: "".concat(baseUrl).concat(image)
            }),
            creator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: creator
            })
        ]
    });
};
MetaTwitter.propTypes = {
    card: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    site: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    creator: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool
};
const MetaOGP = (param)=>{
    let { isImageBaseUrl =false , title ="" , description ="" , locale ="" , type ="" , url ="" , image ="" , imageSecureUrl ="" , siteName ="" , articlePublisher =""  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            locale && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: locale
            }),
            type && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: type
            }),
            url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "".concat(baseUrl).concat(image)
            }),
            imageSecureUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: "".concat(baseUrl).concat(imageSecureUrl)
            }),
            siteName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: siteName
            }),
            articlePublisher && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "article:publisher",
                content: articlePublisher
            })
        ]
    });
};
MetaOGP.propTypes = {
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    locale: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    url: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    imageSecureUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    siteName: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    articlePublisher: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const PageMeta = (param)=>{
    let { title ="" , description ="" , children =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    })
                ]
            }),
            children
        ]
    });
};
const CustomHead = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: children
    });
};
CustomHead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
PageMeta.Robots = Robots;
PageMeta.Custom = CustomHead;
PageMeta.Canonical = Canonical;
PageMeta.CanonicalAlternate = CanonicalAlternate;
PageMeta.Author = Author;
PageMeta.Twitter = MetaTwitter;
PageMeta.OGP = MetaOGP;
PageMeta.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
/* harmony default export */ __webpack_exports__["ZP"] = (PageMeta);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ })

}]);